import Expense from "./expense";
import ApiExpenses from "../../../gd/api/expenses";
import Collection from "../../../data-structures/collection";
import Resources from "../../../resources/resources";
import exportToCsv from "../../../gd-modules/export-to-csv/export-to-csv";
import {EventAccessControl} from "../../event/access-control/access-control";
import {ExpenseAccessControl} from "./access-control/access-control";

const debug = "ExpensesCollection"
// const debug = false

export default class ExpensesCollection extends Collection<Expense> {

    constructor(expenses:Expense[]=[]) {
        super(expenses)
    }

    static async loadForTask(taskId:ID) {

        const expensesData = await ApiExpenses.loadForTask(taskId)

        const resources = new Resources()
        resources.resetExpenses(expensesData)

        await resources.loadMissingData()

        // init from resources
        return new ExpensesCollection(resources.expenses?.models)
    }

    static initFromJson(data:any[]) {

        const models : Expense [] = []
        _.map(data, (expenseData:any)=>{
            models.push(new Expense(expenseData))
        })

        return new ExpensesCollection(models)
    }

    get total():number {
        let total = 0

        this.models.map((expense: Expense)=>{
            total += expense.total
        })

        return total
    }

    exportToCSV(arrayOfFields: any[], arrayOfIds: string[] = [], fileName: string = 'expenses'): void {
        debug && console.log(debug, 'exportToCSV', arrayOfFields, arrayOfIds, fileName)

        const list: any[] = []
        const header: string[] = ['Id']
        _.map(arrayOfFields, field=>{
            header.push(field.label)
        })
        list.push(header)

        _(this.models)
            .filter(model=>_.isEmpty(arrayOfIds) || arrayOfIds.includes(model.id)) // filter according to arrayOfIds if any
            .map(model=>{ // add row for each resource item
                const values: any[] = [model.id] // id always present and is first

                _.map(arrayOfFields, field=>{
                    values.push(field.normalizeToCSVValue(model))
                })

                list.push(values)
            })
            .value()

        exportToCsv(list, '{0}.csv'.f(fileName))
    }

}
